import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { DougArBusinessCardStackBackgroundViewModel } from './doug-ar-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-doug-ar-business-card-stack-business',
  templateUrl: './doug-ar-business-card-stack-background.component.html',
  styleUrls: ['./doug-ar-business-card-stack-background.component.scss'],
  providers: [DougArBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DougArBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: DougArBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
